import * as cart from './cart'
import * as activity from './activity'
import * as filter from './filter'
import * as offer from './offer'
import * as identity from './identity'
import * as order from './order'

// Portal-specific models (common models are added via Object.assign in app.ts)
export const models = {
    activity,
    cart,
    filter,
    identity,
    offer,
    order,
}
